import api from '@shared/api/api'
import {
  loadESMComponentByPackageJSON,
  loadWebPageByPackageJson,
} from '@shared/api/web-components/index'
import { isWippyPackageESMModule, isWippyPackageWebPage } from '@shared/wippy-package/wippy-package'

/**
 * @deprecated
 */
export const API_WEB_COMPONENTS = `http://localhost:5173/web-components` // TODO: should have v1

/**
 * @deprecated
 */
export async function getWebComponentJson(name: string): Promise<object> {
  return (await api().get<object>(`${API_WEB_COMPONENTS}/${name}/package.json`)).data
}

/**
 * @deprecated
 */
export async function importWebComponent(name: string): Promise<string> {
  const json = await getWebComponentJson(name)
  if (!isWippyPackageESMModule(json)) {
    throw new Error(`Invalid Wippy package: ${name} does not match required structure.`)
  }
  return loadESMComponentByPackageJSON({
    uuid: name,
    packageJson: json,
  }, api())
}

/**
 * @deprecated
 */
export async function importWebPage(name: string): Promise<string> {
  const json = await getWebComponentJson(name)
  if (!isWippyPackageWebPage(json)) {
    throw new Error(`Invalid Wippy package: ${name} does not match required structure.`)
  }

  return loadWebPageByPackageJson({
    uuid: name,
    packageJson: json,
  }, api())
}
